/**
 * waitlist-form.js
 * Turns the Halo "notify me" form into a segmentable waitlist by posting to the
 * Waitlist Shopify app via App Proxy instead of the native /contact endpoint.
 *
 * Architecture: Browser → POST /apps/waitlist/subscribe → Waitlist app → Admin API
 *   (customerCreate/Update + tag `waitlist-<handle>` + emailMarketingConsent + metafields)
 *
 * A single delegated submit listener covers every place the form is rendered
 * (PDP inline, popup, edit-cart, quick-view) on both desktop and mobile.
 */

(function () {
  'use strict';

  var CFG = window.waitlist || {};
  var PROXY_URL = CFG.url || '/apps/waitlist/subscribe';

  function val(form, selector) {
    var el = form.querySelector(selector);
    return el ? String(el.value || '').trim() : '';
  }

  function collectUtm() {
    var params = new URLSearchParams(window.location.search);
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
      var v = params.get(k);
      if (v) utm[k.replace('utm_', '')] = v;
    });
    return utm;
  }

  // Show a message inside this form's wrapper and (optionally) hide the fields.
  // The theme hides .notifyMe-text by default, so we add .is-visible to reveal it.
  function showMessage(form, message, isError) {
    var wrapper = form.parentElement || form;
    var box = wrapper.querySelector('.notifyMe-text');
    if (!box) {
      box = document.createElement('div');
      box.className = 'notifyMe-text';
      wrapper.appendChild(box);
    }
    box.classList.add('is-visible');
    box.innerHTML =
      '<div class="alertBox alertBox--' + (isError ? 'error' : 'success') + '">' +
      '<p class="alertBox-message">' + message + '</p></div>';

    if (!isError) {
      form.querySelectorAll('.form-field').forEach(function (f) { f.classList.add('hidden'); });
    }
  }

  async function handleSubmit(e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('notifyMe-form')) return;

    // Intercept: kill the native /contact submit (and any theme handlers) — no page reload.
    e.preventDefault();
    e.stopImmediatePropagation();

    var email = val(form, '[name="contact[email]"]');
    var productHandle = val(form, '.halo-notify-product-handle');
    if (!email) { showMessage(form, CFG.error || 'E-mail inválido.', true); return; }

    // Submitting the form IS the consent. We store the notice text that was on
    // screen at that moment as the record of what the person agreed to.
    var noticeEl = form.querySelector('.notifyMe-consent');
    var consentText = noticeEl ? noticeEl.textContent.trim() : '';

    var payload = {
      email: email,
      opt_in: true,
      consent_text: consentText,
      product_id: val(form, '.halo-notify-product-id'),
      product_handle: productHandle,
      product_title: val(form, '.halo-notify-product-title'),
      product_url: val(form, '.halo-notify-product-link'),
      variant_id: val(form, '.halo-notify-variant-id'),
      variant_title: val(form, '.halo-notify-product-variant'),
      utm: collectUtm(),
    };

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '...'; }

    try {
      var response = await fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      var data = await response.json().catch(function () { return {}; });

      if (!response.ok || !data.success) {
        var msg = (Array.isArray(data.errors) && data.errors.length) ? data.errors.join(', ') : (CFG.error || 'Erro ao cadastrar.');
        throw new Error(msg);
      }
      showMessage(form, CFG.success || 'Cadastro realizado com sucesso!', false);
    } catch (err) {
      console.error('[waitlist]', err);
      showMessage(form, err.message || CFG.error || 'Erro ao cadastrar.', true);
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
    }
  }

  // Delegated: catches forms injected later (popup / quick-view) too.
  document.addEventListener('submit', handleSubmit, true);

  // Open the notify popup from our own triggers (e.g. mobile sold-out CTA) without
  // going through the theme's card-scraping handler, which would corrupt the
  // popup's product fields. The popup already has the correct product context.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-waitlist-open]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation(); // prevent the theme's click-outside handler from closing it
    document.body.classList.add('notify-me-show');
  }, true);
})();
